import { render } from "./PaperItem.vue?vue&type=template&id=5e3bc5ea&scoped=true"
import script from "./PaperItem.vue?vue&type=script&lang=js"
export * from "./PaperItem.vue?vue&type=script&lang=js"

import "./PaperItem.vue?vue&type=style&index=0&id=5e3bc5ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e3bc5ea"]])

export default __exports__